<template>
  <div ref="chartRef" style="width: 100%; height: 300px;"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import * as echarts from 'echarts'

const props = defineProps({
  chartData: {
    type: Array,
    required: true,
  },
})

const chartRef = ref(null)
let chartInstance = null

const initChart = () => {
  if (chartRef.value) {
    chartInstance = echarts.init(chartRef.value)
    updateChart(props.chartData)
  }
}

const updateChart = (data) => {
  if (!chartInstance || !chartRef.value) return
  const isMobile = chartRef.value.clientWidth < 480

  const option = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    grid: {
      left: isMobile ? '2%' : '3%',
      right: isMobile ? '2%' : '4%',
      bottom: isMobile ? '2%' : '3%',
      top: isMobile ? '4%' : '8%',
      containLabel: true,
    },
    xAxis: {
      type: 'value',
      boundaryGap: [0, 0.01],
      axisLabel: {
        fontSize: isMobile ? 11 : 12,
      },
    },
    yAxis: {
      type: 'category',
      data: data.map(item => item.name).reverse(),
      axisLabel: {
        fontSize: isMobile ? 11 : 12,
        formatter: (value) => value.length > 6 && isMobile ? `${value.slice(0, 6)}...` : value,
      },
    },
    series: [
      {
        name: '借用次数',
        type: 'bar',
        data: data.map(item => item.value).reverse(),
        itemStyle: {
          color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
            { offset: 0, color: '#83bff6' },
            { offset: 0.5, color: '#188df0' },
            { offset: 1, color: '#188df0' },
          ]),
        },
        emphasis: {
          itemStyle: {
            color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
              { offset: 0, color: '#2378f7' },
              { offset: 0.7, color: '#2378f7' },
              { offset: 1, color: '#83bff6' },
            ]),
          },
        },
      },
    ],
  }

  chartInstance.setOption(option)
}

const handleResize = () => {
  if (!chartInstance) return
  chartInstance.resize()
  updateChart(props.chartData)
}

onMounted(() => {
  initChart()
  window.addEventListener('resize', handleResize)
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  if (chartInstance) {
    chartInstance.dispose()
    chartInstance = null
  }
})

watch(() => props.chartData, (newData) => {
  updateChart(newData)
})
</script>
